<template>
  <div>
    <section class="section is-title-bar">
      <div class="level">
        <div class="level-left">
          <div class="level-item">
            <h1 class="title is-5">{{ getTitle }}</h1>
          </div>
        </div>
        <router-link slot="right" :to="{ name: 'ListPincodes' }" class="button is-small v-btn theme--light elevation-1 v-size--default primary" color="primary" elevation="1">
          Back to list</router-link
        >
      </div>
    </section>
    <section class="container section page-header section is-main-section">
      <form autocomplete="off" @submit.prevent="addPincode" name="SavePincode">
        <div>
          <card-component>
            <div class="columns form-row">
              <div class="column">
                <div class="field">
                  <label class="label">
                    Franchisee
                     <span class="requir error--text">*</span>
                  </label>
                  <div class="control select is-fullwidth">
                    <select required v-model="pincodeObj.franchiseeID">
                      <option value>---Select---</option>
                      <option :value="franchisee.id" v-for="franchisee in franchiseeArr" :key="franchisee.id">{{ franchisee.companyName }}</option>
                    </select>
                  </div>
                </div>
              </div>
              <div class="column">
                <div class="field">
                  <label class="label">
                    Pincode
                     <span class="requir error--text">*</span>
                  </label>
                  <div class="control">
                    <input class="input" type="number" required  title="Enter Valid Pincode !" @keypress="NumbersOnly($event)" v-model.trim="pincodeObj.pincode" />
                  </div>
                </div>
              </div>
            </div>
            <div class="columns form-row">
              <div class=" column is-6">
                <div class="field">
                  <label class="label">
                    State
                  </label>
                  <div class="control ">
                    <input class="input" type="text" maxlength="15" name="state" v-model.trim="pincodeObj.state" />
                  </div>
                </div>
              </div>
              <div class="column is-6">
                <div class="field">
                  <label class="label">
                    City
                  </label>
                  <div class="control">
                    <input class="input" type="text" maxlength="15" name="city" v-model.trim="pincodeObj.city" />
                  </div>
                </div>
              </div>
            </div>
            <div class="columns form-row">
              <div class="column is-6">
                <div class="field">
                  <label class="label">
                    Location
                  </label>
                  <div class="control">
                    <input class="input" type="text" maxlength="30" name="location" v-model.trim="pincodeObj.location" />
                  </div>
                </div>
              </div>
            </div>
            <footer class="column has-text-right">
              <button class="button is-success" type="submit">Save</button>
            </footer>
          </card-component>
        </div>
      </form>
    </section>
  </div>
</template>
<script>
import CardComponent from '@/components/template/CardComponent'
import constants from '@/utils/constants'
export default {
  name: 'SavePincode',
  props: ['pincodeId'],
  data () {
    return {
      getTitle: 'Add Pincode',
      data: [],
      loadingComponent: null,
      franchiseeArr: [],
      pincodeObj: {
        pincode: '',
        franchiseeID: '',
        state: '',
        city: '',
        location: ''
      }
    }
  },

  created () {
    if (this.$route.params.pincodeId) {
      this.getTitle = 'Edit Pincode'
      this.getPincodeByID(this.$route.params.pincodeId)
    } else {
      this.getTitle = 'Add Pincode'
    }
    this.getDetails()
  },
  components: {
    CardComponent
  },
  beforeRouteLeave (to, from, next) {
    // Ckeditor maximize fix
    if (this.hasDataChanged()) {
      return this.$buefy.dialog.confirm({
        title: 'Leave Page',
        message: 'Do you really want to leave? you have unsaved changes!',
        type: 'is-danger',
        cancelText: 'No',
        confirmText: 'Yes',
        onConfirm: () => {
          next()
        },
        onCancel: () => {
          next(false)
        }
      })
    } else next()
  },
  beforeMount () {
    window.addEventListener('beforeunload', this.preventNav)
  },
  beforeDestroy () {
    window.removeEventListener('beforeunload', this.preventNav)
  },
  methods: {
    preventNav (event) {
      if (!this.hasDataChanged()) return
      event.preventDefault()
      event.returnValue = ''
    },
    hasDataChanged () {
      const boolAlert = this.pincodeObj.pincode || this.pincodeObj.franchiseeID || this.pincodeObj.state || this.pincodeObj.city || this.pincodeObj.location
      return boolAlert
    },
    NumbersOnly (e) {
      var len = (this.pincodeObj.pincode).length
      if (len > 5) {
        e.preventDefault()
      } else if (e.which !== 8 && e.which !== 0 && (e.which < 48 || e.which > 57)) {
        e.preventDefault()
      }
    },
    addPincode: async function () {
      try {
        var len = (this.pincodeObj.pincode).toString().length
        let pincode = parseInt(this.pincodeObj.pincode)
        if (len < 6 || len > 6) {
          return this.errMsg(`Pincode must be six digit`)
        }
        if (pincode < 100000) {
          return this.errMsg(` Please enter valid pincode`)
        }
        this.loadingComponent = this.$buefy.loading.open()
        if (this.$route.params.pincodeId) {
          await http.put(`${constants.API_URL}/api/pincodes/${this.$route.params.pincodeId}`, this.pincodeObj)
          this.okMsg(`Pincode Update Successfully`)
        } else {
          await http.post(`${constants.API_URL}/api/pincodes`, this.pincodeObj)
          this.okMsg(`Pincode Saved successfully`)
        }
        this.loadingComponent.close()
        this.resetFields()
        this.$router.push({ name: 'ListPincodes' })
      } catch (e) {
        this.loadingComponent.close()
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        this.errMsg(`Error While fetching Pincode: ${errorMessage}`)
      }
    },
    getPincodeByID: async function (pincodeId) {
      try {
        const { data } = await http.get(`${constants.API_URL}/api/pincodes/${pincodeId}`)
        if (data) {
          this.pincodeObj.franchiseeID = data.franchiseeID
          this.pincodeObj.pincode = data.pincode
          this.pincodeObj.state = data.state
          this.pincodeObj.city = data.city
          this.pincodeObj.location = data.location
        }
      } catch (e) {
        this.errMsg(e.message)
      }
    },
    getDetails: async function () {
      try {
        const { data } = await http.get(`${constants.API_URL}/api/franchisee/active`)
        this.franchiseeArr = data.rows
      } catch (e) {
        this.errMsg(e.message)
      }
    },
    resetFields: async function () {
      this.pincodeObj.pincode = ''
      this.pincodeObj.franchiseeID = ''
      this.pincodeObj.state = ''
      this.pincodeObj.city = ''
      this.pincodeObj.location = ''
    },
    okMsg (msg) {
      return this.$buefy.dialog.alert({
        type: 'is-success',
        message: msg,
        hasIcon: true,
        animation: 'zoom-out',
        size: 'is-medium',
        icon: ' mdi-exclamation',
        iconPack: 'mdi',
        ariaRole: 'alertdialog',
        ariaModal: true
      })
    },
    errMsg (msg) {
      return this.$buefy.dialog.alert({
        message: msg,
        type: 'is-danger',
        hasIcon: true,
        animation: 'zoom-out',
        size: 'is-medium',
        icon: ' mdi-exclamation',
        iconPack: 'mdi',
        ariaRole: 'alertdialog',
        ariaModal: true
      })
    }
  }
}
</script>
